<template>
  <van-popup
      v-model="showModal"
      round
      position="bottom"
      :style="{ height: orderConfirmed ? 'auto' : 'auto', maxHeight: '90vh' }"
      closeable
      close-icon-position="top-left"
      @close="closePopup"
  >
    <div class="payment-modal-content">
      <div v-if="!orderConfirmed" class="payment-step">
        <p class="title">选择会员套餐</p>
        <van-divider />

        <!-- 会员套餐列表 -->
        <div class="vip-packages">
          <div
              v-for="(item, index) in vipPackages"
              :key="index"
              class="vip-package-item"
              :class="{ 'selected': selectedPackageIndex === index }"
              @click="selectPackage(item, index)"
          >
            <div class="package-banner" v-if="item.discount">{{ item.discount }}</div>
            <div class="package-name">{{ item.hymc }}</div>
            <div class="package-days">有效期 {{ item.hyts }} 天</div>
            <div class="package-price">
              <span class="price-symbol">￥</span>
              <span class="price-value">{{ item.hyjg }}</span>
            </div>
            <div class="package-original-price" v-if="item.originalPrice">
              原价￥{{ item.originalPrice }}
            </div>
          </div>
        </div>

        <div class="agreement-section">
          <van-checkbox v-model="agreementChecked" shape="square" icon-size="15px" checked-color="#00D090">
            <span class="agree-text">我已阅读并同意</span>
            <span class="agreement-link" @click="showAgreement">《会员服务协议》</span>
          </van-checkbox>
        </div>

        <van-button
            class="confirm-pay-btn"
            type="primary"
            block
            @click="createOrder"
            :loading="orderLoading"
        >
          立即开通
        </van-button>
      </div>

      <div v-else class="payment-step">
        <p class="title">立即支付</p>
        <van-divider />

        <div class="order-details">
          <div class="order-row">
            <span class="label">订单名称</span>
            <span class="value">{{ selectedPackage.hymc }}</span>
          </div>
          <van-divider />
          <div class="order-row">
            <span class="label">订单编号</span>
            <span class="value">{{ orderNo }}</span>
          </div>
          <van-divider />
          <div class="order-row">
            <span class="label">创建日期</span>
            <span class="value">{{ formatDate(creationDate) }}</span>
          </div>
          <van-divider />
          <div class="order-row">
            <span class="label">会员时长</span>
            <span class="value">{{ selectedPackage.hyts }}天</span>
          </div>
          <van-divider />
          <div class="order-row">
            <span class="label">价格</span>
            <span class="value price">￥{{ selectedPackage.hyjg }}</span>
          </div>
          <van-divider />

          <p class="payment-method-title">支付方式:</p>
          <div class="payment-methods">
            <div
                class="payment-method-item"
                @click="selectPaymentMethod('alipay')"
                :class="{ 'active': selectedPayment === 'alipay' }"
            >
              <div class="method-info">
                <svg-icon icon="icon17" />
                <span>支付宝</span>
              </div>
              <van-radio v-model="selectedPayment" name="alipay" checked-color="#00D090" />
            </div>
            <div
                class="payment-method-item"
                @click="selectPaymentMethod('wechat')"
                :class="{ 'active': selectedPayment === 'wechat' }"
            >
              <div class="method-info">
                <svg-icon icon="icon18" />
                <span>微信支付</span>
              </div>
              <van-radio v-model="selectedPayment" name="wechat" checked-color="#00D090" />
            </div>
          </div>
        </div>

        <van-button
            class="confirm-pay-btn"
            type="primary"
            block
            @click="confirmPay"
            :loading="payLoading"
        >
          确认并支付￥{{ selectedPackage.hyjg }}元
        </van-button>
      </div>
    </div>

    <!-- 协议弹窗 -->
    <van-popup v-model="showAgreementPopup" round position="bottom" :style="{ height: '80%' }">
      <div class="agreement-content">
        <h3>会员服务协议</h3>
        <div class="agreement-text">
          <p>尊敬的会员用户，欢迎使用康康医生会员服务。请您仔细阅读以下条款：</p>
          <p>1. 会员权益：开通会员后，您将享受专属问诊权益、专业数据查询、个人定制服务、24小时在线咨询等专属服务。</p>
          <p>2. 服务期限：会员有效期自开通之日起计算，到期后需续费方可继续享受会员权益。</p>
          <p>3. 退款政策：虚拟商品一经售出，不支持退款，请谨慎购买。</p>
          <p>4. 使用规范：会员账号仅供本人使用，不得转让、出租或共享给他人。</p>
          <p>5. 服务变更：平台保留根据实际情况调整会员权益的权利，如有变更将提前通知。</p>
          <p>6. 其他：如有任何疑问，请联系客服处理。</p>
        </div>
        <van-button type="primary" block @click="showAgreementPopup = false">我已阅读并同意</van-button>
      </div>
    </van-popup>
  </van-popup>
</template>

<script>
import { getMemberType, newOrder, alipay, weiChatPay, orderStatus } from '@/api/vip'
import { Toast, Popup, Button, Divider, Checkbox, Radio, Dialog  } from 'vant'
export default {
  name: 'VipPaymentModal',
  props: {
    memberInfo: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      showModal: false,
      orderConfirmed: false,
      orderLoading: false,
      payLoading: false,
      agreementChecked: false,
      selectedPackage: null,
      selectedPackageIndex: 0,
      selectedPayment: 'alipay',
      vipPackages: [],
      orderNo: '',
      orderId: '',
      creationDate: '',
      aliPayUrl: '',
      weiChatPayUrl: '',
      paymentTimer: null,
      showAgreementPopup: false
    }
  },
  watch: {
    showModal(val) {
      if (val) {
        this.loadVipPackages()
      } else {
        this.resetState()
      }
    }
  },
  beforeDestroy() {
    this.stopPaymentPolling()
  },
  methods: {
    // 重置状态
    resetState() {
      this.orderConfirmed = false
      this.orderLoading = false
      this.payLoading = false
      this.agreementChecked = false
      this.selectedPayment = 'alipay'
      this.orderNo = ''
      this.orderId = ''
      this.creationDate = ''
    },

    // 加载会员套餐
    async loadVipPackages() {
      try {
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        const { result } = await getMemberType({ hyxt: 5, yhid: userInfo.yhid })
        if (result && result.length > 0) {
          // 为套餐添加原价（假设原价是现价的2倍）
          this.vipPackages = result.map(item => ({
            ...item,
            originalPrice: item.hyjg * 2,
            discount: '5折'
          }))
          this.selectedPackage = this.vipPackages[0]
          this.selectedPackageIndex = 0
        } else {
          Toast('暂无可用套餐')
        }
      } catch (error) {
        console.error('加载套餐失败', error)
        Toast('加载套餐失败，请重试')
      }
    },

    // 选择套餐
    selectPackage(item, index) {
      this.selectedPackage = item
      this.selectedPackageIndex = index
    },
    // 跳转到订单列表
    goToOrderList() {
      this.showModal = false
      if (this.$router) {
        this.$router.push('/orderList')
      } else {
        window.location.href = '/#/orderList'
      }
    },
    // 创建订单
    async createOrder() {
      if (!this.agreementChecked) {
        Toast('请先阅读并同意会员服务协议')
        return
      }

      if (!this.selectedPackage) {
        Toast('请选择套餐')
        return
      }

      this.orderLoading = true

      try {
        const userInfo = JSON.parse(sessionStorage.getItem('userInfo'))
        const { result, resultCode, resultDesc } = await newOrder({
          ddjg: this.selectedPackage.hyjg,
          ddlx: 1,
          ddsp: this.selectedPackage.hylxid,
          spsl: 1,
          cjr: userInfo.yhid
        })

        if (resultCode === 200) {
          // 获取支付链接
          await this.getPaymentUrls(result.ddbh, this.selectedPackage.hyjg)

          this.orderNo = result.ddbh
          this.orderId = result.ddid
          this.creationDate = result.cjrq
          this.orderConfirmed = true

          // 开始轮询支付状态
          this.startPaymentPolling()
        } else {
          // 处理重复订单的情况
          if (resultDesc && resultDesc.includes('未支付')) {
            Dialog.confirm({
              title: '提示',
              message: resultDesc + '，是否前往订单列表处理？',
              confirmButtonText: '前往订单列表',
              cancelButtonText: '稍后处理'
            }).then(() => {
              // 确认前往订单列表
              this.goToOrderList()
            }).catch(() => {
              // 取消，只关闭弹窗
              this.showModal = false
            })
          } else {
            Toast(resultDesc || '创建订单失败')
          }
        }
      } catch (error) {
        console.error('创建订单失败', error)
        Toast('创建订单失败，请重试')
      } finally {
        this.orderLoading = false
      }
    },

    // 获取支付链接
    async getPaymentUrls(orderNo, price) {
      try {
        // 获取支付宝支付链接
        const alipayRes = await alipay({ ddbh: orderNo, price: price })
        if (alipayRes.resultDesc) {
          this.aliPayUrl = alipayRes.resultDesc
        }

        // 获取微信支付链接
        const wechatRes = await weiChatPay({ ddbh: orderNo, price: Math.round(price * 100) })
        if (wechatRes.resultDesc) {
          this.weiChatPayUrl = wechatRes.resultDesc
        }
      } catch (error) {
        console.error('获取支付链接失败', error)
      }
    },

    // 选择支付方式
    selectPaymentMethod(method) {
      this.selectedPayment = method
    },

    // 确认支付
    confirmPay() {
      let payUrl = ''
      if (this.selectedPayment === 'alipay') {
        payUrl = this.aliPayUrl
      } else {
        payUrl = this.weiChatPayUrl
      }

      if (payUrl) {
        this.payLoading = true
        // 在新窗口打开支付链接
        window.open(payUrl, '_blank')
        // 继续轮询支付状态
        setTimeout(() => {
          this.payLoading = false
        }, 2000)
      } else {
        Toast('获取支付链接失败，请重试')
      }
    },

    // 开始轮询支付状态
    startPaymentPolling() {
      this.paymentTimer = setInterval(() => {
        this.checkPaymentStatus()
      }, 3000)
    },

    // 停止轮询
    stopPaymentPolling() {
      if (this.paymentTimer) {
        clearInterval(this.paymentTimer)
        this.paymentTimer = null
      }
    },

    // 检查支付状态
    async checkPaymentStatus() {
      try {
        const { result } = await orderStatus({ ddid: this.orderId })
        if (result === 2) {
          // 支付成功
          this.stopPaymentPolling()
          Toast.success('支付成功')
          this.showModal = false
          this.$emit('payment-success')
        }
      } catch (error) {
        console.error('查询支付状态失败', error)
      }
    },

    // 关闭弹窗
    closePopup() {
      this.stopPaymentPolling()
      this.resetState()
    },

    // 显示协议
    showAgreement() {
      this.showAgreementPopup = true
    },

    // 格式化日期
    formatDate(dateTime) {
      if (dateTime) {
        return new Date(dateTime).toLocaleString()
      }
      return ''
    }
  }
}
</script>

<style scoped lang="scss">
.payment-modal-content {
  padding: 20px 16px 30px;

  .title {
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    margin-bottom: 16px;
    color: #333;
  }

  .vip-packages {
    display: flex;
    overflow-x: auto;
    gap: 12px;
    padding: 10px 0 20px;
    margin: 0 -4px;

    .vip-package-item {
      flex-shrink: 0;
      width: 120px;
      background: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 12px;
      padding: 16px 12px;
      text-align: center;
      position: relative;
      cursor: pointer;
      transition: all 0.3s;

      &.selected {
        border: 2px solid #00D090;
        background: rgba(0, 208, 144, 0.05);
      }

      .package-banner {
        position: absolute;
        top: -1px;
        right: -1px;
        background: linear-gradient(135deg, #05D5B8, #258CF2);
        color: #fff;
        font-size: 10px;
        padding: 2px 8px;
        border-radius: 0 12px 0 12px;
      }

      .package-name {
        font-size: 16px;
        font-weight: 600;
        color: #333;
        margin-bottom: 8px;
      }

      .package-days {
        font-size: 11px;
        color: #8C8C8C;
        background: #F7F7F7;
        display: inline-block;
        padding: 2px 8px;
        border-radius: 4px;
        margin-bottom: 12px;
      }

      .package-price {
        .price-symbol {
          font-size: 12px;
          color: #333;
        }
        .price-value {
          font-size: 22px;
          font-weight: bold;
          color: #333;
        }
      }

      .package-original-price {
        font-size: 11px;
        color: #8C8C8C;
        text-decoration: line-through;
        margin-top: 4px;
      }

      &.selected .package-price .price-value {
        color: #00D090;
      }
    }
  }

  .agreement-section {
    display: flex;
    justify-content: center;
    margin: 20px 0;

    .agree-text {
      font-size: 12px;
      color: #595959;
    }

    .agreement-link {
      font-size: 12px;
      color: #00D090;
      cursor: pointer;
    }
  }

  .confirm-pay-btn {
    background: linear-gradient(270deg, #05D5B8 0%, #258CF2 100%);
    border: none;
    border-radius: 8px;
    height: 46px;
    font-size: 16px;
    font-weight: 500;
  }

  .order-details {
    background: linear-gradient(180deg, rgba(227, 255, 253, 0.3) 0%, #FFFFFF 100%);
    border-radius: 12px;
    padding: 16px;
    margin-bottom: 20px;

    .order-row {
      display: flex;
      justify-content: space-between;
      padding: 8px 0;

      .label {
        font-size: 14px;
        color: #8C8C8C;
      }

      .value {
        font-size: 14px;
        color: #333;

        &.price {
          font-size: 18px;
          font-weight: bold;
          color: #00D090;
        }
      }
    }

    .payment-method-title {
      font-size: 14px;
      color: #333;
      margin: 12px 0 8px;
    }

    .payment-methods {
      .payment-method-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 0;
        border-bottom: 1px solid #f0f0f0;
        cursor: pointer;

        &:last-child {
          border-bottom: none;
        }

        .method-info {
          display: flex;
          align-items: center;
          gap: 12px;

          svg-icon {
            width: 24px;
            height: 24px;
          }

          span {
            font-size: 14px;
            color: #333;
          }
        }
      }
    }
  }
}

.agreement-content {
  padding: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;

  h3 {
    text-align: center;
    margin-bottom: 20px;
    font-size: 18px;
  }

  .agreement-text {
    flex: 1;
    overflow-y: auto;
    font-size: 14px;
    line-height: 1.8;
    color: #666;

    p {
      margin-bottom: 12px;
    }
  }

  .van-button {
    margin-top: 16px;
    background: linear-gradient(270deg, #05D5B8 0%, #258CF2 100%);
    border: none;
  }
}

// 自定义 Dialog 样式
::v-deep  .van-dialog {
  border-radius: 12px;

  .van-dialog__header {
    font-size: 18px;
    font-weight: 600;
    padding-top: 20px;
  }

  .van-dialog__message {
    padding: 20px;
    font-size: 14px;
    color: #666;
  }

  .van-dialog__footer {
    padding: 0 20px 20px;

    .van-button {
      border-radius: 8px;
      font-weight: 500;
    }

    .van-button--default {
      border-color: #ddd;
      color: #666;
    }

    .van-button--primary {
      background: linear-gradient(270deg, #05D5B8 0%, #258CF2 100%);
      border: none;
    }
  }
}
</style>
